<body class="d-flex flex-column min-vh-100">
	<main class="form-signin text-center w-100 m-auto px-3">
		<div class="card shadow-lg bg-dark rounded px-3 px-md-5 pb-4 pt-3 mt-4 mt-md-0">
            <div class="card-header border-bottom-0 pb-0">
                <img class="sub-logo img-fluid mb-2" src="assets/images/biorugged.png" alt="BioRugged Logo">
                <div class="biorugged-title">BioRugged SDK Manager</div>
            </div>
            <div class="card-body px-0">
                <form #loginForm="ngForm">
                    @if (!isOtpMode) {
                        <div class="form-floating mb-3">
                            <input type="text" id="floatingInput" class="form-control" placeholder="Username" [(ngModel)]="username" name="username" autocomplete="new">
                            <label for="floatingInput">Username</label>
                        </div>
                        <div class="form-floating mb-3 position-relative">
                            <input 
								[type]="showPassword ? 'text' : 'password'" 
								id="floatingPassword" 
								class="form-control pe-5" 
								placeholder="Password" 
								[(ngModel)]="password" 
								name="password" 
								autocomplete="new-password">
							<label for="floatingPassword">Password</label>

                            <span 
								class="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" 
								style="cursor: pointer; z-index: 10;" 
								(click)="togglePasswordVisibility()">
								
								@if (showPassword) {
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
									<path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"/>
									<path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"/>
									<path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"/>
									</svg>
								} @else {
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
									<path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
									<path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
									</svg>
								}
							</span>
                        </div>
                        
                        @if (showFailed) {
                            <div class="row">
                                <div class="col alert alert-danger">{{error ? error : 'Login failed'}}</div>
                            </div>
                        }

                        <div class="row mb-3">
                            <div class="col d-flex justify-content-center">
                                <div id="turnstile-widget"></div>
                            </div>
                        </div>                        
                        <div class="row mb-2">
							<div class="col">
								<button 
									class="w-100 btn btn-lg btn-primary d-flex justify-content-center align-items-center gap-2" 
									type="submit" 
									[disabled]="isLoading" 
									(click)="doSignIn()">
									
									@if (isLoading) {
										<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
									}
									
									SIGN IN
								</button>
							</div>
						</div>
                    } @else {
                        <div class="text-center mb-4 mt-2">
                            <p class="text-white">A verification code has been sent to your registered email address.</p>
                        </div>
                        
                        <div class="form-floating mb-3 position-relative">
                            <input 
                                [type]="showOtp ? 'text' : 'password'" 
                                id="floatingOtp" 
                                class="form-control text-center fs-3 fw-bold pe-5" 
                                placeholder="000000" 
                                [(ngModel)]="otpCode" 
                                name="otpCode" 
                                autocomplete="one-time-code" 
                                maxlength="6">
                            <label for="floatingOtp">Verification Code</label>
                            
                            <span 
                                class="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" 
                                style="cursor: pointer; z-index: 10;" 
                                (click)="toggleOtpVisibility()">
                                
                                @if (showOtp) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"/>
                                    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"/>
                                    <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"/>
                                    </svg>
                                } @else {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                                    </svg>
                                }
                            </span>
                        </div>
                        
                        @if (showFailed) {
                            <div class="row">
                                <div class="col alert alert-danger">{{error ? error : 'Verification failed'}}</div>
                            </div>
                        }

                        <div class="row mb-2">
                            <div class="col">
                                <button 
                                    class="w-100 btn btn-lg btn-primary d-flex justify-content-center align-items-center gap-2" 
                                    type="submit" 
                                    [disabled]="isLoading" 
                                    (click)="doVerifyOtp()">
                                    @if (isLoading) {
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    }
                                    VERIFY CODE
                                </button>
                            </div>
                        </div>
                        <div class="text-center mt-3">
                            <a href="javascript:void(0)" class="text-decoration-none small hover-primary transition-all" (click)="cancelOtp()">
                                Cancel and return to login
                            </a>
                        </div>
                    }
                </form>
            </div>
        </div>
    </main>

    <footer class="footer text-center py-4 text-muted w-100">
        <a href="#">Privacy Policy</a> | <a href="#">Terms of Service</a>
        <div class="mt-1">&copy; 2026 SDK Manager. All rights reserved.</div>
    </footer>
</body>